<label class="m-featureCheckbox">
  <input
    type="checkbox"
    class="m-featureCheckbox__input"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="onCheckboxChange($event)"
  />
  <span class="m-featureCheckbox__label">{{ label() }}</span>
</label>
